module.exports = __webpack_public_path__ + "static/media/confirm-plan-android-mweb.351e21a2.webp";